var _circle, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0252,
    cy: 12,
    r: 12,
    fill: "#97144D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0392 11.0091L13.0179 8.98788L14.4789 7.52613L16.4994 9.54663L15.0392 11.0091ZM9.83492 16.2186L7.60217 16.4219L7.80017 14.2049L12.0129 9.99213L14.0349 12.0141L9.83492 16.2186ZM17.5779 8.50338L17.5772 8.50263L15.5237 6.44913C14.9679 5.89488 14.0132 5.86863 13.4867 6.39738L6.73967 13.1444C6.49517 13.3881 6.34367 13.7121 6.31217 14.0549L6.02792 17.1824C6.00842 17.4036 6.08717 17.6226 6.24467 17.7801C6.38642 17.9219 6.57767 17.9999 6.77492 17.9999C6.79817 17.9999 6.82067 17.9991 6.84317 17.9969L9.97067 17.7126C10.3142 17.6811 10.6374 17.5304 10.8812 17.2866L17.6289 10.5389C18.1749 9.99138 18.1517 9.07788 17.5779 8.50338Z",
    fill: "#171A21"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3238_22842",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 13,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0392 11.0091L13.0179 8.98788L14.4789 7.52613L16.4994 9.54663L15.0392 11.0091ZM9.83492 16.2186L7.60217 16.4219L7.80017 14.2049L12.0129 9.99213L14.0349 12.0141L9.83492 16.2186ZM17.5779 8.50338L17.5772 8.50263L15.5237 6.44913C14.9679 5.89488 14.0132 5.86863 13.4867 6.39738L6.73967 13.1444C6.49517 13.3881 6.34367 13.7121 6.31217 14.0549L6.02792 17.1824C6.00842 17.4036 6.08717 17.6226 6.24467 17.7801C6.38642 17.9219 6.57767 17.9999 6.77492 17.9999C6.79817 17.9999 6.82067 17.9991 6.84317 17.9969L9.97067 17.7126C10.3142 17.6811 10.6374 17.5304 10.8812 17.2866L17.6289 10.5389C18.1749 9.99138 18.1517 9.07788 17.5779 8.50338Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3238_22842)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.02521,
    y: 3,
    width: 18,
    height: 18,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircle);
export default __webpack_public_path__ + "static/media/icon_circle.96157815f7bfe854373da4f27b3413d0.svg";
export { ForwardRef as ReactComponent };